module.exports = __webpack_public_path__ + "static/business-areas-lg-5b252bc458097994152cbf4bf7798d4a.jpg";